export default __webpack_public_path__ + "static/media/retrainPricing.baa7cd5d.svg";